  // Hardcoded list of authorized users who can always see the close alert button
  export const authorizedUsers = [
    'mathieu.beliveau@riotinto.com',
    'jonathan.fortin@riotinto.com',
    'simon.bouchard4@riotinto.com',
    'zakariya.elkssir@riotinto.com',
    'pier-luc.bouchard4@riotinto.com'
  ];